import PropTypes from 'prop-types';
import React from 'react';
import { browserHistory } from 'react-router';
import ReactDOM from 'react-dom';

import Label from '../../../common/Label.js.jsx';
import CustomIcon from '../../../common/CustomIcon.js.jsx';

import MessageSelector from '../../messages/MessageSelector.js.jsx';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ShowMessageFreqCap } from '../../../../components/dialogue/scenarios/versionTwo/components/scenario_records_2.js';
import { Message } from '../../../../records/message_records';
import MessageDescription from './MessageDescription';

export default class extends React.Component {

    static propTypes = {
        editing: PropTypes.bool.isRequired,
        data:PropTypes.instanceOf(ShowMessageFreqCap).isRequired,
        onChange: PropTypes.func.isRequired,
        messages: ImmutablePropTypes.orderedSetOf(PropTypes.instanceOf(Message)).isRequired,
    }

    constructor(props) {
        super(props);
        this.state = {
            timesShow: this.props.data.n,
            secondsLasts: this.props.data.t,
        };
        this.handleMessageChange = this.handleMessageChange.bind(this);
        this.handleTimesChange = this.handleTimesChange.bind(this);
        this.handleSecondsChange = this.handleSecondsChange.bind(this);
        this.handleNumberChange = this.handleNumberChange.bind(this);
    }

    componentDidMount(){
        if (this.props.editing) ReactDOM.findDOMNode(this.refs.message).focus();
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.data) {
            this.setState({
                timesShow: nextProps.data.n,
                secondsLasts: nextProps.data.t,
            })
        }
    }

    handleMessageChange(event) {
        const data = this.props.data.set('message_id', (parseInt(event.target.value) || undefined));
        this.props.onChange(data);
    }

    handleTimesChange(event) {
        this.handleNumberChange(event, "times")
    }

    handleSecondsChange(event) {
        this.handleNumberChange(event, "seconds")
    }

    handleNumberChange(event, toChange) {
        var value = parseInt(event.target.value);

        if (isNaN(value)) {
            toChange === 'times' ? this.setState({ timesShow: '' }) : this.setState({ secondsLasts: '' });
        } else {
            let dataParam;
            if (toChange === 'times') {
                dataParam = 'n';
                this.setState({ timesShow: value });
            } else {
                this.setState({ secondsLasts: value });
                dataParam = 't';
            }
            this.props.onChange(this.props.data.set(dataParam, value));
        }
    }

    render() {

        var messageID = this.props.data.message_id;

        const message = this.props.messages.find(message => message.get('id') === messageID);

        let previewIcon;
        if (message && message.getIn(['msg_metadata', 'type']) !== "redirect") {
            previewIcon = (
                <CustomIcon
                  type={ CustomIcon.types.PREVIEW }
                  onClick={ () => browserHistory.push('/dialogue/message_preview?message_id=' + messageID + '&site_id=' + message.site_id) }
                />
            )
        }

        const wrapperClassNames = "step message-frec-cap"
        if (!this.props.editing) {
            return (
                <div className={ wrapperClassNames }>
                  <span className="message-to-preview">Message: {
                    message ?
                      <MessageDescription message={ message } /> :
                      "UNKNOWN"
                    }, show max { this.state.timesShow || this.props.data.n } times every { this.state.secondsLasts || this.props.data.t } seconds
                  </span>
                  { previewIcon }
                </div>
            );
        } else {
            return (
                <div className={ wrapperClassNames }>
                  <label>Message:</label>
                  <MessageSelector ref="message" value={ message ? messageID : -1 } messages={ this.props.messages } onChange={ this.handleMessageChange }/>

                  <label>show max</label>
                  <input className="times" type="text" value={ this.state.timesShow } onChange={ this.handleTimesChange }></input>

                  <label>times every</label>
                  <input className="seconds" type="text" value={ this.state.secondsLasts } onChange={ this.handleSecondsChange }></input>
                  <label>seconds</label>
                </div>
            );
        }
    }
}
